import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   const className = 'affiliate-disclaimer__content--hide'
   const selector = '.affiliate-disclaimer__title'
   if (document.querySelector(selector)) {
      Listener.onClick(document.querySelector(selector), event => {
         event.currentTarget.closest('.affiliate-disclaimer')
            .querySelector('.affiliate-disclaimer__content').classList.toggle(className)
      })
      Listener.onClickAll('.js-closeDisclaimer', event => {
         event.currentTarget.closest('.affiliate-disclaimer__content').classList.add(className)
      })
   } else {
      console.log('selector' + selector + ' is NULL')
   }
})